import React from 'react';
import { SideSheetContainer } from 'cdk-radial';
import styled from 'styled-components';

interface DataSideSheet {
  children: React.ReactNode;
  isCollapse: boolean;
  sidesheetName?: string;
}

export const StyledSideSheetContainer = styled(SideSheetContainer)`
  border-radius: 16px;
  border: none;
  bottom: 16px;
  box-shadow: 0px 8px 25px 2px rgba(21, 27, 37, 0.35);
  font-family: 'Montserrat', 'Roboto', 'sans-serif';
  height: auto;
  margin-right: ${({ isCollapsed }) => (isCollapsed ? '-450px' : 0)};
  position: fixed;
  right: 8px;
  top: 56px;
  z-index: 1002;
  min-width: 420px;
  border: ${({ theme }) => (theme.darkMode ? '2px solid gray' : 'none')};
  @media (max-width: 440px) {
    width: 100vw;
    min-width: 0px;
    right: 0px;
  }
`;

export const BaseSideSheet = ({
  children,
  isCollapse,
}: DataSideSheet): JSX.Element => {
  return (
    <StyledSideSheetContainer data-testid="side-sheet" isCollapsed={isCollapse}>
      {children}
    </StyledSideSheetContainer>
  );
};
